export const ru = {
    'any-days-selected': {
        one: '{count} день в неделю',
        some: '{count} дня в неделю',
        many: '{count} дней в неделю',
        none: '{count} дней в неделю'
    },
    'arbitrary-time': 'Произвольный',
    daily: 'Ежедневно',
    friday: 'ПТ',
    hour24: 'Круглосуточно',
    monday: 'ПН',
    'not-show': 'Не показывать',
    'range-time': 'Диапазон',
    saturday: 'СБ',
    show: 'Показывать',
    sunday: 'ВС',
    thursday: 'ЧТ',
    tuesday: 'ВТ',
    wednesday: 'СР',
    weekdays: 'По будням',
    weekends: 'По выходным',
    'work-time': 'Рабочее время'
};
